import type { ZodObject, ZodRawShape } from "zod";
import { ContentType } from "./ContentType.js";
import { brownCardBlockSchema } from "./content-blocks/brownCardBlockSchema.js";
import { buttonBlockSchema } from "./content-blocks/buttonBlockSchema.js";
import { ckEditorBlockSchema } from "./content-blocks/ckEditorBlockSchema.js";
import { galleryBlockSchema } from "./content-blocks/galleryBlockSchema.js";
import { imageTextBlockSchema } from "./content-blocks/imageTextBlockSchema.js";
import { videoTextBlockSchema } from "./content-blocks/videoTextBlockSchema.js";

export const contentBlockSchemaMap = {
	[ContentType.BrownCard]: brownCardBlockSchema,
	[ContentType.Gallery]: galleryBlockSchema,
	[ContentType.CKEditor]: ckEditorBlockSchema,
	[ContentType.ImageText]: imageTextBlockSchema,
	[ContentType.VideoText]: videoTextBlockSchema,
	[ContentType.Button]: buttonBlockSchema,
} satisfies Record<ContentType, ZodObject<ZodRawShape>>;
